import { render, staticRenderFns } from "./NewRequestDemo.vue?vue&type=template&id=16d3255b&scoped=true"
import script from "./NewRequestDemo.vue?vue&type=script&lang=js"
export * from "./NewRequestDemo.vue?vue&type=script&lang=js"
import style0 from "./NewRequestDemo.vue?vue&type=style&index=0&id=16d3255b&prod&lang=scss"
import style1 from "./NewRequestDemo.vue?vue&type=style&index=1&id=16d3255b&prod&lang=scss&scoped=true"
import style2 from "./NewRequestDemo.vue?vue&type=style&index=2&id=16d3255b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d3255b",
  null
  
)

export default component.exports